<template>
  <grid-item
    v-editable="cms"
    :class="[name, `${name}__grid-item`]"
    :layout="[{ size: 1, x: cms.x, y: cms.y, width: 1 }]"
    :style="mainCssVars"
  >
    <transition name="fade">
      <a-image-v2
        v-if="(cms.image || {}).filename"
        :src="cms.image.filename"
        :alt="cms.image.alt"
        :layout="[{ size: 0, bound: 417, ratio: [400, 400] }]"
        :class="`${name}__image`"
      />
    </transition>
  </grid-item>
</template>

<script>
import data from '@/components/molecules/m-square/m-square.data'
import AImageV2 from '@/components/atoms/a-images/a-image-v2'
import Colors from '@/mixins/colors'

export default {
  components: { AImageV2 },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return process.env.NODE_ENV === 'development' ? { ...data } : {}
      },
    },
  },
  data() {
    return {
      name: 'm-square',
    }
  },
  computed: {
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || 'transparent',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#212121'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--filter': this.cms.filter || null,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-square {
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: stretch;

  &::before {
    content: '';
    display: inline-block;
    width: 1px;
    height: 0;
    padding-bottom: calc(100% / (1 / 1));
  }

  ::v-deep a,
  ::v-deep .a-cta,
  ::v-deep button {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  ::v-deep img {
    filter: var(--filter);
  }

  &__grid {
    align-items: center;
  }
}
</style>
